import SVG from './image.svg';
import { face } from '~/notations';

export default {
  SVG,
  algorithm: [
    face.r.two,
    face.f.two,
    face.r.two,
  ],
  name: 'UB & D Diagonal',
};
